import { render, staticRenderFns } from "./VariantSifterGeTissueDotMenu.vue?vue&type=template&id=acaa5806&scoped=true&"
import script from "./VariantSifterGeTissueDotMenu.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGeTissueDotMenu.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGeTissueDotMenu.vue?vue&type=style&index=0&id=acaa5806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa5806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acaa5806')) {
      api.createRecord('acaa5806', component.options)
    } else {
      api.reload('acaa5806', component.options)
    }
    module.hot.accept("./VariantSifterGeTissueDotMenu.vue?vue&type=template&id=acaa5806&scoped=true&", function () {
      api.rerender('acaa5806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGeTissueDotMenu.vue"
export default component.exports